import {StyleSheet, Dimensions} from 'react-native';
import {styles} from 'src/theme';
import {customResponsiveWidth} from '../../../../../../utils/CustomResponsive';
import {windowWidth} from '../../../../../../constants';
const {width, height} = Dimensions.get('window');
export default StyleSheet.create({
  slide: {
    alignItems: 'center',
    height: '100%',
    backgroundColor: 'blue',
    width: '100%',
  },
  title: {
    color: '#303261',
    fontSize: 18,
    marginBottom: 14,
    fontFamily: styles.font.IranYekan[400],
  },
  text: {
    color: '#303261',
    fontSize: 14,
    marginBottom: 50,
    fontFamily: styles.font.IranYekan[400],
    textAlign: 'center',
  },
  textContainer: {
    width: windowWidth - 30,
    alignItems: 'center',
  },
  buttontext: {
    fontSize: 18,
    fontFamily: styles.font.IranYekan[400],
  },
  btncontainer: {
    width: '100%',
    paddingHorizontal: 24,
    paddingBottom: 24,
    height: 120,
    position: 'absolute',
    bottom: 0,
    justifyContent: 'flex-end',
  },
  imageContainer: {
    padding: 10,
    justifyContent: 'center',
    backgroundColor: '#fff',
    alignItems: 'center',
    width: customResponsiveWidth(52),
    height: customResponsiveWidth(52),
    borderRadius: 18,
  },
  container: {
    flex: 1,
    backgroundColor: '#fff',
    paddingHorizontal: 4,
    alignItems: 'center',
    justifyContent: 'center',
  },
  header: {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginBottom: 10,
  },

  description: {
    color: '#5A5A5A',
    fontSize: 13,
    fontFamily: styles.font.IranYekan[400],
    textAlign: 'center',
    paddingVertical: 3,
    paddingHorizontal: 15,
  },
  linkButton: {
    paddingVertical: 8,
  },
  linkText: {
    color: '#223EB9',
    fontSize: 14,
    fontFamily: styles.font.IranYekan[400],
    textAlign: 'center',
  },
  tabs: {
    flexDirection: 'row',
    marginBottom: 16,
    borderBottomWidth: 1,
    borderColor: '#ECEDF0',
    flex: 1,
    width: '95%',
  },
  tab: {
    flex: 0.8,
    alignItems: 'center',
  },
  activeTab: {
    borderBottomWidth: 3,
    borderColor: '#F34F42',
  },
  tabText: {
    fontSize: 14,
    fontFamily: styles.font.IranYekan[400],
    textAlign: 'center',
    color: '#434343',
  },
  activeTabText: {
    color: '#B91618',
    fontSize: 14,
    fontFamily: styles.font.IranYekan[400],
    textAlign: 'center',
  },
  cardsContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    width: '95%',
  },
  card: {
    marginBottom: 16,
    borderRadius: 8,
    overflow: 'hidden',
    backgroundColor: '#fff',
    flex: 1,
  },
  cardIcon: {
    position: 'absolute',
    top: 0,
    right: 10,
  },
  description: {
    color: '#555',
    paddingHorizontal: 10,
    fontSize: 14,
    fontFamily: styles.font.IranYekan[400],
    textAlign: 'center',
  },
  overlay: {
    flex: 1,
    justifyContent: 'flex-end',
    backgroundColor: 'rgba(0,0,0,0.4)',
  },
  sheet: {
    backgroundColor: '#fff',
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    padding: 16,
  },
  header: {
    width: '98%',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginBottom: 10,
  },
  headerTitle: {
    color: '#2D2D2D',
    fontSize: 14,
    fontFamily: styles.font.IranYekan[400],
    textAlign: 'flex-end',
    paddingRight: 12,
    marginLeft: 'auto',
  },
  closeBtn: {
    alignSelf: 'flex-start',
  },
});
